import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class ModuleBackground {
	constructor(elm) {
        this.background = elm;

        this.trigger = ScrollTrigger.create({
            trigger:  this.background,
            start: "top bottom",
            onEnter: () => {
                this.background.classList.add('section-group--visible');
            }
        });

    }

    destroy() {
       this.trigger.kill();
    }
}